<template>
  <div id="skillList">
    <p class="title">技能列表
      <router-link to="/createSkill" class="pull-right">
        <el-button type="primary" class="el-button-small" size="mini" round >创建技能</el-button>
      </router-link>
    </p>
    <!--<div class="SkillContainer" style="padding:0 30px">-->
    <!--&lt;!&ndash;<p>{{dateFormat_new(1516787761.659447)}}</p>&ndash;&gt;-->
    <!--<div class="editionList">-->
    <div style="padding: 0 30px;">
      <template>
        <el-table
          id="tableSkill"
          :data="tableData"
          style="width: 100%">
          <el-table-column
            prop="chinese_name"
            align="center"
            label="技能名称">
          </el-table-column>
          <el-table-column
            prop="skill_id"
            align="center"
            width="250"
            label="技能ID">
          </el-table-column>
          <el-table-column
            align="center"
            label="技能类型">
            <template slot-scope="scope">
              {{scope.row.open_skill_type | openSkillType}}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="审核状态">
            <template slot-scope="scope">
              {{scope.row.online | audited_type}}
              <!--{{scope.row.audited ? '已通过' : '未审核'}}-->
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            align="center"
            label="时间">
          </el-table-column>
          <el-table-column
            align="center"
            label="操作">
            <template slot-scope="scope">
              <!--<router-link :to="{path: `/intentionList?skillId=${scope.row.skill_id}`, params: {skillId: scope.row.skill_id}}">-->
              <!--:disabled="scope.row.online == 3 || scope.row.online == 5"-->
              <el-button type="text" size="mini" @click="routeA(scope.row.skill_id,scope.row.online, scope.row.open_skill_type)">编辑</el-button>
              <!--</router-link>-->
              <!--<el-button type="danger" icon="el-icon-delete" size="mini"-->
                         <!--@click="deleteClick(scope.row.skill_id)"></el-button>-->
              <!--<i class="iconfont icon-shanchu" @click="deleteClick(scope.row.skill_id)"></i>-->
            </template>
          </el-table-column>
        </el-table>
      </template>
      <el-dialog
        title="删除"
        :visible.sync="dialogVisible"
        width="30%">
        <span>确定删除这个技能吗？</span>
        <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="deleteSkill">确 定</el-button>
  </span>
      </el-dialog>
    </div>
  </div>
  <!--</div>-->
  <!--</div>-->
</template>
<script>
  import qs from 'qs'
  import CommonMethods from '@/mixins/commonMethods'
  import {skillDetailApi, getUserId, SkillListApi, deleteSkillApi} from '@/api'

  export default {
    mixins: [
      CommonMethods
    ],
    data() {
      return {
        dev_id: '',
        skillId: null,
        tableData: [],
        dialogVisible: false
      }
    },
    created() {
      this.getList()
    },
    methods: {
      routeA(id, online, open_skill_type) {
          this.$store.dispatch("changeSkillName",'')
//          `/intentionList?skillId=${scope.row.skill_id}`
        if (online ==3 || online == 5) {
          localStorage.setItem('onlineFlag', '1')
        } else {
          localStorage.setItem('onlineFlag', '0')
        }
        if (open_skill_type == 2) { // 智能家居类型跳转到配置服务页
            this.$router.push(`/service?skillId=${id}&online=${online}`)
        } else { // 其他类型跳转到意图列表页
            this.$router.push(`/intentionList?skillId=${id}&online=${online}`)

        }
//        let _this = this
//        async function getDetial() {
//          let res = await skillDetailApi({"skill_id":id,"online":online})
//          if (res){
//            _this.$store.dispatch("changeSkillName", res.data.data.skill_name);
//          }
//        }
//        getDetial()

      },
      async getList() {
        let data = await getUserId()
        if (data.data.code == 200) {
          this.dev_id = data.data.data.id
          let res = await SkillListApi(data.data.data.id)
          if (res.data.code == 200) {
            this.tableData = res.data.data.skills
          } else if (res.data.code == 400) {
            this.$message({message: '当前网络状况异常，请稍后再试！', type: 'error'})
          } else if (res.data.code == 401) {
            window.location.href = '/login'
          } else {
            this.$message({message: res.data.errors.data, type: 'error'})
          }
        }
      },
      deleteClick(id) {
        console.log(id)
        this.dialogVisible = true
        this.skillId = id
//            this.deleteSkill(id)
      },
      async deleteSkill() {
        this.dialogVisible = false
        let res = await deleteSkillApi(this.skillId, qs.stringify({dev_id: this.dev_id}))
        if (res.data.code == 200) {
          this.$message({message: `删除成功`, type: 'success'})
          this.getList()
        } else if (res.data.code == 401) {
          window.location.href = '/login'
        } else {
          this.$message({message: res.data.errors.data, type: 'error'})
        }
      }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss">
  #skillList {
    background: #fff;
    min-height: 100%;
    padding: 90px 30px 30px 30px;
    p {
      button {
        width: 145px;
        margin-bottom: 20px;
        margin-right: 30px;
      }
    }
    .title {
      height: 64px;
      line-height: 64px;
      padding-left: 30px;
      font-size: 16px;
      font-weight: 800;
      color: #2e4d79;
      margin-bottom: 30px;
      border-bottom: 1px solid #f5f5f5;
      border-left: 2px solid #010202;
      .pull-right {
        float: right;
      }
    }
    .editionList {
      padding: 30px;
    }
    .el-button-small{
      padding: 9px 15px;
      height: 34px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/skilloverview/SkillList.vue